import FxTransfer from './FxTransfer';

export { FxTransfer };
